import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '../../selectors/user';
import { useApplicationContext } from '../../utils/withApplicationContext';

/**
 * Баннер "Циан.Ипотека для профи" может быть показан?
 */
export const useIsMortgageBrokerBannerAvailable = (): boolean => {
  const { config } = useApplicationContext();
  const user = useSelector(getUser);

  const isBannerEnabled = !!config.get<boolean>('Transaction.MortgageBrokerMainBannerInObjectCard.Enabled');

  return useMemo(
    () => Boolean(isBannerEnabled && user.isAuthenticated && user.isAgent && !user.isBuilder),
    [isBannerEnabled, user],
  );
};
